/* Home hero — live all-time order counter.
   Reads the count from the configured Worker endpoint, animates a count-up,
   then re-polls so the chip ticks up as new orders land. If the endpoint is
   unreachable or returns nothing usable, the chip keeps its server-rendered
   fallback text — it never shows a wrong or zero number. */
(function () {
  var el = document.querySelector('[data-order-counter]');
  if (!el) return;

  var endpoint = el.getAttribute('data-endpoint');
  if (!endpoint) return;
  var prefix = el.getAttribute('data-prefix') || '';
  var suffix = el.getAttribute('data-suffix') || '';

  var current = 0;
  var shown = false;
  var raf;

  function render(n) {
    var num = Math.round(n).toLocaleString();
    el.textContent = (prefix ? prefix + ' ' : '') + num + (suffix ? ' ' + suffix : '');
  }

  function animateTo(target) {
    if (prefersReduced()) {
      render(target);
      current = target;
      shown = true;
      return;
    }
    // First reveal counts up from a little below; later updates ease the delta.
    var start = shown ? current : Math.max(0, target - Math.min(target, 80));
    var t0 = null;
    var dur = shown ? 700 : 1500;
    cancelAnimationFrame(raf);
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      render(start + (target - start) * eased);
      if (p < 1) {
        raf = requestAnimationFrame(step);
      } else {
        current = target;
        shown = true;
      }
    }
    raf = requestAnimationFrame(step);
  }

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function poll() {
    fetch(endpoint, { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && typeof d.count === 'number' && d.count > 0 && d.count !== current) {
          el.classList.add('is-live');
          animateTo(d.count);
        }
      })
      .catch(function () { /* keep fallback text */ });
  }

  poll();
  setInterval(poll, 45000);
})();
